import { apiFetch, apiFetchJson } from '@wundo/client/api.ts';
import type { PaginatedResponse } from '@/types/pagination.ts';
import { PAGE_SIZE } from '@/lib/pageSize.ts';

export type SkillBroadcastStatus = 'pending' | 'dispatched' | 'cancelled';

export interface SkillBroadcast {
  id: string;
  skill_id: string;
  skill_name: string;
  cohorts: { id: string; title: string; organisation_name: string }[];
  reason: string | null;
  scheduled_for: string;
  send_at: string | null;
  status: SkillBroadcastStatus;
  recipient_count: number | null;
  dispatched_at: string | null;
  created_at: string;
}

export interface CreateSkillBroadcastRequest {
  skill_id: string;
  cohort_ids: string[];
  scheduled_for: string;
  send_at?: string;
  reason?: string;
}

export function listSkillBroadcasts(
  page = 1,
  limit: number = PAGE_SIZE,
): Promise<PaginatedResponse<SkillBroadcast>> {
  return apiFetchJson<PaginatedResponse<SkillBroadcast>>(
    `/skill-broadcasts?page=${page}&limit=${limit}`,
  );
}

export function createSkillBroadcast(
  body: CreateSkillBroadcastRequest,
): Promise<{ id: string }> {
  return apiFetchJson<{ id: string }>('/skill-broadcasts', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}

/* Answers 204, so there is nothing to read back. */
export async function cancelSkillBroadcast(id: string): Promise<void> {
  await apiFetch(`/skill-broadcasts/${id}/actions/cancel`, { method: 'POST' });
}
